import { types } from './actions';

const initialState = {};

export default function reducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case types.SUBMIT_STRIPE_UPDATE_REQUEST:
      return {};
    case types.SUBMIT_STRIPE_UPDATE_SUCCESS:
      payload.onSuccess();
      return {};
    case types.SUBMIT_STRIPE_UPDATE_ERROR:
      payload.onError();
      return {};
    default:
      return state;
  }
}
